import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/faq/listFaqs.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var getFaqs = (params) => __async(void 0, null, function* () {
  try {
    const locale = getLocaleOnly((params == null ? void 0 : params.locale) || "en");
    const data = yield fetchClient({
      url: `/faqs?lang=${locale}`
    });
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getFaqsException"
    });
  }
});

export {
  getFaqs
};
//# sourceMappingURL=chunk-7OK33QSG.mjs.map